import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8 8-3.5817 8-8-3.5817-8-8-8M2 12C2 6.4772 6.4772 2 12 2s10 4.4772 10 10-4.4772 10-10 10S2 17.5228 2 12",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.6001 9c0-.5523.4477-1 1-1h16.8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-16.8c-.5523 0-1-.4477-1-1m0 6c0-.5523.4477-1 1-1h16.8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-16.8c-.5523 0-1-.4477-1-1",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.0296 2.1518c.4685.2924.6113.9092.3189 1.3777a16 16 0 0 0 0 16.9412c.2924.4686.1496 1.0854-.3189 1.3778s-1.0854.1496-1.3778-.319a18 18 0 0 1 0-19.0588c.2924-.4685.9092-.6113 1.3778-.319",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.9707 2.1518c.4686-.2924 1.0854-.1496 1.3778.319a18 18 0 0 1 0 19.0587c-.2924.4686-.9092.6114-1.3778.319s-.6113-.9092-.3189-1.3778a16 16 0 0 0 0-16.9411c-.2924-.4686-.1496-1.0854.3189-1.3778",
        clipRule: "evenodd"
    }, "3")
], "Globe", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
